export const isUnknownApiEndpointError = (error) => {
  const responseData = error?.response?.data;
  if (!responseData || responseData.code !== 'DEVICE_NETWORK_OPERATION_FAILED') {
    return false;
  }

  const nestedMessage = responseData?.data?.error_message || responseData.message || '';
  if (typeof nestedMessage !== 'string') {
    return false;
  }

  return nestedMessage.toLowerCase().includes('unknown api endpoint');
};
